import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BadgeAvatars from './BadgeAvatars';
import ClientProvider from './client';
export default createDemo(import.meta.url, BadgeAvatars, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/avatars/demos/badge/BadgeAvatars.tsx",
    "fileName": "BadgeAvatars.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport Badge from '@mui/material/Badge';\nimport Avatar from '@mui/material/Avatar';\nimport Stack from '@mui/material/Stack';\nimport InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';\n\nconst StyledBadge = styled(Badge)(({ theme }) => ({\n  '& .MuiBadge-badge': {\n    backgroundColor: '#44b700',\n    color: '#44b700',\n    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,\n    '&::after': {\n      position: 'absolute',\n      top: 0,\n      left: 0,\n      width: '100%',\n      height: '100%',\n      borderRadius: '50%',\n      animation: 'ripple 1.2s infinite ease-in-out',\n      border: '1px solid currentColor',\n      content: '\"\"',\n    },\n  },\n  '@keyframes ripple': {\n    '0%': {\n      transform: 'scale(.8)',\n      opacity: 1,\n    },\n    '100%': {\n      transform: 'scale(2.4)',\n      opacity: 0,\n    },\n  },\n}));\n\nconst SmallAvatar = styled(Avatar)(({ theme }) => ({\n  width: 22,\n  height: 22,\n  border: `2px solid ${theme.palette.background.paper}`,\n}));\n\nexport default function BadgeAvatars() {\n  return (\n    <Stack direction=\"row\" spacing={2}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <StyledBadge\n        overlap=\"circular\"\n        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}\n        variant=\"dot\"\n      >\n        <Avatar alt=\"Remy Sharp, online\" src=\"/static/images/avatar/1.jpg\" />\n      </StyledBadge>\n      <Badge\n        overlap=\"circular\"\n        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}\n        badgeContent={2}\n        color=\"primary\"\n      >\n        <Avatar\n          alt=\"Travis Howard, 2 unread messages\"\n          src=\"/static/images/avatar/2.jpg\"\n        />\n      </Badge>\n      <Badge\n        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}\n        badgeContent={<SmallAvatar alt=\"\" src=\"/static/images/avatar/1.jpg\" />}\n      >\n        <InsertDriveFileIcon\n          color=\"action\"\n          fontSize=\"large\"\n          titleAccess=\"Q4 budget spreadsheet, last edited by Remy Sharp\"\n        />\n      </Badge>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 75,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport Badge from '@mui/material/Badge';\nimport Avatar from '@mui/material/Avatar';\nimport Stack from '@mui/material/Stack';\nimport InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';\n\nconst StyledBadge = styled(Badge)(({ theme }) => ({\n  '& .MuiBadge-badge': {\n    backgroundColor: '#44b700',\n    color: '#44b700',\n    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,\n    '&::after': {\n      position: 'absolute',\n      top: 0,\n      left: 0,\n      width: '100%',\n      height: '100%',\n      borderRadius: '50%',\n      animation: 'ripple 1.2s infinite ease-in-out',\n      border: '1px solid currentColor',\n      content: '\"\"',\n    },\n  },\n  '@keyframes ripple': {\n    '0%': {\n      transform: 'scale(.8)',\n      opacity: 1,\n    },\n    '100%': {\n      transform: 'scale(2.4)',\n      opacity: 0,\n    },\n  },\n}));\n\nconst SmallAvatar = styled(Avatar)(({ theme }) => ({\n  width: 22,\n  height: 22,\n  border: `2px solid ${theme.palette.background.paper}`,\n}));\n\nexport default function BadgeAvatars() {\n  return (\n    <Stack direction=\"row\" spacing={2}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <StyledBadge\n        overlap=\"circular\"\n        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}\n        variant=\"dot\"\n      >\n        <Avatar alt=\"Remy Sharp, online\" src=\"/static/images/avatar/1.jpg\" />\n      </StyledBadge>\n      <Badge\n        overlap=\"circular\"\n        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}\n        badgeContent={2}\n        color=\"primary\"\n      >\n        <Avatar\n          alt=\"Travis Howard, 2 unread messages\"\n          src=\"/static/images/avatar/2.jpg\"\n        />\n      </Badge>\n      <Badge\n        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}\n        badgeContent={<SmallAvatar alt=\"\" src=\"/static/images/avatar/1.jpg\" />}\n      >\n        <InsertDriveFileIcon\n          color=\"action\"\n          fontSize=\"large\"\n          titleAccess=\"Q4 budget spreadsheet, last edited by Remy Sharp\"\n        />\n      </Badge>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "totalLines": 75,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Badge",
      "@mui/material/Avatar",
      "@mui/material/Stack",
      "@mui/icons-material/InsertDriveFile"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
